
import { useChurchBranding } from "@/contexts/ChurchBrandingContext";
import { useTheme } from "@/components/ui/theme-provider";

interface DevotionalHeaderProps {
  title: string;
  scriptureText: string;
  scriptureReference: string;
}

export function DevotionalHeader({
  title,
  scriptureText,
  scriptureReference,
}: DevotionalHeaderProps) {
  const { branding } = useChurchBranding();
  const { theme } = useTheme();

  const getTextColor = () => {
    return theme === "dark" ? "text-app-text-primary" : "text-app-text-primary";
  };

  const getCardClasses = () => {
    if (theme === "dark") {
      return "card-base p-6 rounded-xl bg-app-surface-elevated border-app-border";
    }
    return "card-base p-6 rounded-xl bg-app-surface border-app-border";
  };

  const getSecondaryTextColor = () => {
    return theme === "dark" ? "text-app-text-secondary" : "text-app-text-muted";
  };

  return (
    <section className="mb-8 md:mb-10">
      {branding?.logoUrl && (
        <div className="flex items-center justify-center gap-3 mb-6 animate-fade-in">
          <img 
            src={branding.logoUrl} 
            alt={branding?.churchName || "Church Logo"} 
            className="h-12 w-auto object-contain drop-shadow-lg"
          />
          
          {branding?.churchName && (
            <div className="flex flex-col">
              <span className={`text-caption ${getSecondaryTextColor()}`}>
                Welcome to
              </span>
              <h2 className={`text-title font-grace ${getTextColor()}`}>
                {branding.churchName}
              </h2>
            </div>
          )}
        </div>
      )}
      
      <h1 className={`text-display text-center mb-6 font-grace animate-slide-up ${getTextColor()}`}>
        {title}
      </h1>
      
      <div className="text-center space-y-4 max-w-4xl mx-auto animate-slide-up" style={{ animationDelay: "0.2s" }}>
        <blockquote className={`text-xl md:text-2xl leading-relaxed font-verse italic px-4 ${getCardClasses()}`}>
          <span className={getTextColor()}>
            "{scriptureText}"
          </span>
        </blockquote>
        <p className={`text-title font-semibold tracking-wide font-grace ${getTextColor()}`}>
          {scriptureReference}
        </p>
      </div>
    </section>
  );
}
